import {
  CarePlanNoteStatusHistoryResponse,
  OrderedEnumeration,
} from '~/lib/types/carePlan/carePlans';
import { ChakraFlex, FAIconName, Icon, Tag } from '@equip.health/ui';
import { getTagColorByCarePlanGoalStatusCode } from '~/components/maud/patients/profile/tabs/careplan/CarePlanGoalTagDropdownOptions';

type Props = {
  id: string;
  status: OrderedEnumeration;
  statusHistories: CarePlanNoteStatusHistoryResponse[];
};
export const PatientNoteItemCarePlanStatusHistory = ({
  id,
  status,
  statusHistories,
}: Props) => {
  if (statusHistories.length === 0) {
    // unexpected case, default to status value
    return (
      <Tag
        id={`care-plan-goal-status-${id}`}
        value={status.label}
        color={getTagColorByCarePlanGoalStatusCode(status.code)}
      />
    );
  }
  if (statusHistories.length === 1) {
    return (
      <Tag
        id={`care-plan-goal-status-${id}`}
        value={statusHistories[0].statusTo.label}
        color={getTagColorByCarePlanGoalStatusCode(
          statusHistories[0].statusTo.code,
        )}
      />
    );
  }
  const earliestStatusHistory = statusHistories.at(-1);
  if (
    earliestStatusHistory.statusTo.code === statusHistories[0].statusTo.code
  ) {
    return (
      <Tag
        id={`care-plan-goal-status-${id}`}
        value={statusHistories[0].statusTo.label}
        color={getTagColorByCarePlanGoalStatusCode(
          statusHistories[0].statusTo.code,
        )}
      />
    );
  }
  return (
    <ChakraFlex alignItems="center" gap="10px">
      <Tag
        id={`care-plan-goal-status-from-${id}`}
        value={earliestStatusHistory.statusTo.label}
        color={getTagColorByCarePlanGoalStatusCode(
          earliestStatusHistory.statusTo.code,
        )}
      />
      <Icon
        color="accent.blue"
        name={FAIconName.arrowRightRegular}
        aria-hidden={false}
        aria-label="Changed to"
      />
      <Tag
        id={`care-plan-goal-before-status-to-${id}`}
        value={statusHistories[0].statusTo.label}
        color={getTagColorByCarePlanGoalStatusCode(
          statusHistories[0].statusTo.code,
        )}
      />
    </ChakraFlex>
  );
};
